import { render, staticRenderFns } from "./partnershipsComponent.vue?vue&type=template&id=0a7014ce&scoped=true"
import script from "./partnershipsComponent.vue?vue&type=script&lang=js"
export * from "./partnershipsComponent.vue?vue&type=script&lang=js"
import style0 from "./partnershipsComponent.vue?vue&type=style&index=0&id=0a7014ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7014ce",
  null
  
)

export default component.exports